import { getHostedUserAuthMethodsOptions, postHostedUserVaultDecrypt } from '@onefootprint/fetch-hosted';
import type { AuthMethod } from '@onefootprint/request-types';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { checkDeviceInfo, type DeviceInfo } from '@/idv2/utils/get-device';
import { getLogger } from '@/idv2/utils/logger';
const {
  logWarn
} = getLogger({
  name: 'idv2',
  location: 'auth-methods-layout'
});
export type AuthMethodsLayoutData = {
  authMethods: AuthMethod[];
  decryptedEmail?: string;
  decryptedPhone?: string;
  deviceInfo: DeviceInfo;
  token: string;
};
export const Route = createFileRoute('/auth-methods')({
  component: () => <Outlet />,
  loader: async ({
    context
  }): Promise<AuthMethodsLayoutData> => {
    const token = context.onboardingSessionToken;
    if (!token) {
      throw new Error('No auth token available for auth-methods');
    }
    const headers = {
      'X-Fp-Authorization': token
    };
    const [authMethodsData, deviceInfo, decryptedData] = await Promise.all([context.queryClient.ensureQueryData(getHostedUserAuthMethodsOptions({
      headers
    })), checkDeviceInfo(), postHostedUserVaultDecrypt({
      headers,
      body: {
        fields: ['id.email', 'id.phone_number']
      }
    }).then(res => res.data).catch(err => {
      logWarn('Failed to decrypt user data', err);
      return undefined;
    })]);
    return {
      authMethods: authMethodsData ?? [],
      decryptedEmail: decryptedData?.['id.email'] ?? undefined,
      decryptedPhone: decryptedData?.['id.phone_number'] ?? undefined,
      deviceInfo,
      token
    };
  }
});